export default "__VITE_ASSET__433a1ab3__"